(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-hg-announcement]').forEach((bar) => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const messages = [...bar.querySelectorAll('[data-hg-message]')];
      let index = 0;
      function show(direction) {
        index = (index + direction + messages.length) % messages.length;
        messages.forEach((message, i) => { message.hidden = i !== index; });
      }
      bar.querySelector('[data-hg-prev]').addEventListener('click', () => show(-1));
      bar.querySelector('[data-hg-next]').addEventListener('click', () => show(1));
    });
    root.querySelectorAll('[data-hg-price-sort]').forEach((select) => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    root.querySelectorAll('.hg-sort').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', (event) => {
        const url = new URL(form.action, location.origin);
        const data = new FormData(form);
        if (event.submitter?.name === 'sort_by') data.set('sort_by', event.submitter.value);
        for (const [key, value] of data) if (value) url.searchParams.append(key, value);
        event.preventDefault();
        location.assign(url);
      });
    });
    root.querySelectorAll('[data-hg-reviews]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const track = section.querySelector('.hg-review-track');
      const scroll = (direction) => track.scrollBy({ left: direction * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      section.querySelector('[data-hg-review-prev]')?.addEventListener('click', () => scroll(-1));
      section.querySelector('[data-hg-review-next]')?.addEventListener('click', () => scroll(1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
